export enum EPreferences {
  PRINTING_MATERIAL_SEPARATION = "PRINTING_MATERIAL_SEPARATION",
  ROUND_PRICING = "ROUND_PRICING",
  System_VAT = "System_VAT",
  DEFUALT_AUTO_DISCOUNT = "DEFUALT_AUTO_DISCOUNT",
  DOCUMENT_AGENT = "DOCUMENT_AGENT",
  PRODUCTION_TICKET_SIZE = "PRODUCTION_TICKET_SIZE",
  SHOW_PHONE_PREFIX = "SHOW_PHONE_PREFIX",
  SET_QUOTE_CREATOR_AS_QUOTE_AGENT = "SET_QUOTE_CREATOR_AS_QUOTE_AGENT",
  ADDITIONAL_DELIVERY_TIME = "ADDITIONAL_DELIVERY_TIME",
  SHOW_DISCOUNT_ITEMS = "SHOW_DISCOUNT_ITEMS",
  DELIVERY_TICKET_SIZE = "DELIVERY_TICKET_SIZE",
  SHOW_DELIVERY_ITEMS = "SHOW_DELIVERY_ITEMS",
  IGNORE_IN_CALCULATED_WORKFLOWS = "IGNORE_IN_CALCULATED_WORKFLOWS",
  SHOW_GRAPHICS_ITEMS = "SHOW_GRAPHICS_ITEMS",
  IS_BUSINESS_NUMBER_REQUIRED_IN_CUSTOMERS = "IS_BUSINESS_NUMBER_REQUIRED_IN_CUSTOMERS",
  BOARDMISSION_PDF_FORMAT = "BOARDMISSION_PDF_FORMAT",
  SHOW_AGENT_IN_PRODUCTION_FLOOR = "SHOW_AGENT_IN_PRODUCTION_FLOOR",
  PRODUCTION_FLOOR_TABLE_FONT_SIZE = "PRODUCTION_FLOOR_TABLE_FONT_SIZE",
  SHOW_PRODUCT_NAME_COLUMN_IN_PRODUCTION_FLOOR = "SHOW_PRODUCT_NAME_COLUMN_IN_PRODUCTION_FLOOR",
  SHOW_DESCRIPTION_COLUMN_IN_PRODUCTION_FLOOR = "SHOW_DESCRIPTION_COLUMN_IN_PRODUCTION_FLOOR",
  SHOW_NOTES_COLUMN_IN_PRODUCTION_FLOOR = "SHOW_NOTES_COLUMN_IN_PRODUCTION_FLOOR",
  RUSH_FEE = "RUSH_FEE",
  HIDE_VAT_FROM_DOCUMENTS = "HIDE_VAT_FROM_DOCUMENTS",
  ADDRESSES_WITH_COUNTRY_AND_STATE = "ADDRESSES_WITH_COUNTRY_AND_STATE",
  ADDRESSES_REQUIRED_FOR_ORDER = "ADDRESSES_REQUIRED_FOR_ORDER",
  HIDE_ITEM_CODE_FROM_DOCUMENT_CART = "HIDE_ITEM_CODE_FROM_DOCUMENT_CART",
  USE_PRINTNODE_AFTER_PREPRESS = "USE_PRINTNODE_AFTER_PREPRESS"
}
